export const INVOICE_APPROVED = 'InvoiceApproved';
export const INVOICE_DECLINED = 'InvoiceDeclined';
export const INVOICE_PDF_GENERATED = 'InvoicePdfGenerated';
export const INSURANCE_CREATED = 'InsuranceCreated';
export const INSURANCE_ACCEPTED = 'InsuranceAccepted';
export const INSURANCE_TERMINATED = 'InsuranceTerminated';
export const INSURANCE_VARIATION_UPDATED = 'InsuranceVariationUpdated';
export const INSURANCE_BANK_DETAILS_UPDATED = 'InsuranceBankDetailsUpdated';
export const INSURANCE_POLICY_PDF_GENERATED = 'InsurancePolicyPdfGenerated';
export const BALANCE_CORRECTION_CREATED = 'BalanceCorrectionCreated';
export const CONTACT_PERSON_CHANGED = 'ContactPersonChanged';
export const CUSTOMER_UPDATES_EMAIL = 'CustomerUpdatesEmail';
export const CUSTOMER_UPDATES_PHONE_NUMBER = 'CustomerUpdatesPhoneNumber';
export const BALANCE_CORRECTION_PROCESSED = 'BalanceCorrectionProcessed';
export const WINBACK_CREATED = 'WinbackCreated';
